import {
  FiniteListFilter,
  FiniteListProps,
} from "stories/filters/finite-list-filter/FiniteListFilter";

export const targetEntityOptions = [
  { value: "DOCUMENT", label: "Document" },
  { value: "PLP", label: "PLP" },
  { value: "PROJECT", label: "Project" },
  { value: "ENTITY", label: "Entity" },
];

export default (props: FiniteListProps) => {
  return (
    <FiniteListFilter
      {...props}
      data={targetEntityOptions.map((option, i) => {
        return {
          key: i,
          title: option.label,
          value: option.value,
        };
      })}
    />
  );
};